import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const UserIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        className="tenera-icon"
        {...props}
    >
        <path
            d="M15.3778 19.8013C17.8208 19.8013 19.8013 17.8208 19.8013 15.3778C19.8013 12.9348 17.8208 10.9543 15.3778 10.9543C12.9348 10.9543 10.9543 12.9348 10.9543 15.3778C10.9543 17.8208 12.9348 19.8013 15.3778 19.8013Z"
            fill="currentColor"
            className="accent"
        />
        <path
            d="M2.82912 22.4019C1.6657 20.3239 1 17.9287 1 15.3779C1 7.43924 7.43924 1 15.3779 1C23.3165 1 29.7557 7.43924 29.7557 15.3779C29.7557 17.9287 29.09 20.3239 27.9266 22.4019"
            stroke="currentColor"
            className="primary"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.4276 23.2667C17.7296 23.2667 19.596 23.9884 20.6723 24.9714C21.5496 25.774 22.0411 26.8005 22.0411 26.8005C22.2588 27.2485 22.3832 27.6529 22.4517 27.9515C20.3861 29.1025 18.0095 29.7557 15.4774 29.7557H15.3779C12.8457 29.7557 10.4691 29.1025 8.40356 27.9515C8.47822 27.6529 8.59643 27.2485 8.81418 26.8005C8.81418 26.8005 9.30568 25.7802 10.1829 24.9714C11.253 23.9884 13.1506 23.2667 15.4276 23.2667Z"
            fill="currentColor"
            className="accent"
        />
    </svg>
);

export default withCustomIcon(UserIcon);